import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { IClient, IClientsFilter } from './clients.interface';
import { ClientsService } from './clients.service';
import { ClientsModalComponent } from './clients-modal/clients-modal.component';
import { ClientTypes } from './clients.constants';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { DialogService } from '../../../shared/services/dialog/dialog.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { AuthService } from '../../../shared/services/auth.service';
import { IConfirmationDialogOptions } from '../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { HelpVideoModalComponent } from '../../../shared/components/help-video-modal/help-video-modal.component';
import { ExternalRequestModalComponent } from '../../../shared/components/external-request/external-request-modal/external-request-modal.component';

let self: any;

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.css']
})
export class ClientsComponent implements OnInit {
  clients: IClient[] = [];
  loading: boolean = true;
  thereAreMore: boolean = false;
  filter: IClientsFilter = {
    filters: {
      isDeleted: false
    },
    sort: '',
    skip: 0,
    limit: 20
  };
  filterAllData: IClientsFilter = {
    filters: {},
    sort: '',
    skip: 0,
    limit: 20
  };
  filtered = false;
  totalMoreMinTutorial = false;
  scrollSubscription!: Subscription;
  querySubscription!: Subscription;
  sortOptions: any = {
    "lastname": 'Apellido asc',
    "-lastname": 'Apellido desc',
    "firstname": 'Nombre asc',
    "-firstname": 'Nombre desc',
  };
  sortOptionsKeys = Object.keys(this.sortOptions);
  selection: any = { all: false };
  isDev!: boolean;
  clienTypes: any = ClientTypes;
  safeSrc: SafeResourceUrl;

  constructor(
    private _ClientsService: ClientsService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private router: Router,
    private _route: ActivatedRoute,
    private _AuthService: AuthService,
    private _UtilService: UtilsService,
    private sanitizer: DomSanitizer
  ) {
    self = this;
    this.registerStringBroadcast();
    this.registerQueryParamChanges();
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/pbA4V9Y_Zhs?si=8EFTq9aLvtwggccn");
  }

  registerQueryParamChanges() {
    this.querySubscription = this._route.queryParams.subscribe(params => {
      if (params['action'] && parseInt(params['tp'] || '0') > (new Date().getTime() - (10 * 1000)) && (params['action'] == 'NEW'))
        setTimeout(() => this.openNewClientModal());
    })
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.filter.company = this._AuthService.companyId();
    this.filterAllData.company = this.filter.company;
    this._ClientsService.getClientsCount(this.filterAllData).subscribe((count: any) => {
      this.totalMoreMinTutorial = count <= 3;
      this.getClients(true);
    });
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    this.filtered = true;
    setTimeout(() => {
      console.log(tmp, this.lazySearchTmp);
      if (tmp == this.lazySearchTmp) {
        this.getClients(true);
      }
    }, 1000);
  }

  getClients(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.clients = [];
      this.clearSelection();
    }
    this._ClientsService.getClients(this.filter).subscribe((clients: any) => {
      // console.log(clients)
      this.clients = _.concat(this.clients, clients.map((el: IClient) => {
        el.addresses?.forEach(add => {
          const aux = (add.address || '').split(',');
          add.address = (aux[0] || '') + ', ' + (aux[1] || '');
          return add;
        })
        return el;
      }));
      const filter: any = this.filter;
      this.thereAreMore = clients.length >= filter.limit;
      this.loading = false;
    })
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getClients();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
    this.querySubscription.unsubscribe();
  }

  sortClients(sort: any) {
    this.filter.sort = (typeof sort == 'string') ? sort : ((sort.direction == 'asc') ? '' : '-') + sort.active;
    this.getClients(true);
  }

  openFilter() {
    console.log('openFilter');
  }

  clearFilter() {
    this.filter.filters = { isDeleted: false };
    this.getClients(true);
  }

  openHelpVideoModal() {
    let config = new MatDialogConfig();
    config.width = '1100px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(HelpVideoModalComponent, config);
    self.dialogRef.componentInstance.helpLink = this.safeSrc;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getClients(true);
    });
  }

  openNewClientModal() {
    this.openClientModal({});
  }

  openClientModal(client: IClient, readOnly: boolean = false) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '1100px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(ClientsModalComponent, config);
    self.dialogRef.componentInstance.client = client;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getClients(true);
    });
  }

  openExternalRequestModal(client: IClient) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(ExternalRequestModalComponent, config);
    self.dialogRef.componentInstance.client = client;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getClients(true);
    });
  }

  openDeleteClientConfirm(client: IClient, hardDelete: boolean = false) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Client",
      message: `Esta seguro que desea eliminar cliente ${client.lastname || client.firstname || ''}?`,
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._ClientsService.deleteClient(client, hardDelete).subscribe(() => {
            if (!hardDelete) client.isDeleted = true;
            this.getClients(true);
          })
        }
      });
  }

  openRestoreClientConfirm(category: IClient) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Restaurar Client",
      message: "Esta seguro que desea restaurar '" + category.lastname + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._ClientsService.restoreClient(category).subscribe(() => {
            category.isDeleted = false;
            this.getClients(true);
          })
        }
      });
  }

  clearSelection() {
    this.selection = { all: false }
  }

  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }

  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];

      // Verificar si todos los elementos están seleccionados
      const allSelected = this.clients.every(client => {
        const id = client?._id || '';
        return this.selection[id];
      });

      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };

      // Aplicar el nuevo estado a todos los elementos
      this.clients.forEach(client => {
        const id = client?._id || '';
        this.selection[id] = newValue;
      });
    }

    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }
}